import React from "react";
import { useParams } from "react-router-dom";
import { LifeBuoy } from "lucide-react";
import { AppFlowViewer } from "../../components/appflow/AppFlowViewer";

/** Phase 222 — Citizen Portal Help: the citizen's own App Flow (opened from the Help icon in the header). */
export default function CitizenHelp() {
  const { code } = useParams();
  return (
    <div className="space-y-4" data-testid="citizen-help">
      <div>
        <h1 className="font-heading text-2xl font-semibold flex items-center gap-2"><LifeBuoy className="h-6 w-6 text-primary" /> Help</h1>
        <p className="text-sm text-muted-foreground">How to use the Citizen Portal, step by step — with a picture for every step. · नागरिक पोर्टल का उपयोग कैसे करें, हर चरण की तस्वीर के साथ।</p>
      </div>
      <AppFlowViewer fetchPath={`/t/${code}/app-flow`} exportPath={`/t/${code}/app-flow/export.pptx`} />
    </div>
  );
}
